import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";
import { handleApiError } from "../handleApiError";

const API_URL = "/jobApplications";

// ✅ GET ALL
export const getJobApplications = createAsyncThunk(
  "jobApplication/getAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = new URLSearchParams();
      if (params.page) query.append("page", params.page);
      if (params.limit) query.append("limit", params.limit);

      const response = await axiosInstance.get(
        `${API_URL}?${query.toString()}`,
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message },
      );
    }
  },
);

// ✅ GET ONE
export const getJobApplicationById = createAsyncThunk(
  "jobApplication/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message },
      );
    }
  },
);

// ✅ DELETE
export const deleteJobApplication = createAsyncThunk(
  "jobApplication/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${API_URL}/${id}`);

      toast.success("تم حذف طلب التوظيف بنجاح");
      return { id };
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(
        error.response?.data || { message: error.message },
      );
    }
  },
);
